import { render } from "./ModuleNavBarEntry.vue?vue&type=template&id=2b6655e0"
import script from "./ModuleNavBarEntry.vue?vue&type=script&lang=js"
export * from "./ModuleNavBarEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__